import {useMutation} from '@apollo/react-hooks';

import type {
    googleSetInitialSyncSettings as GoogleSetInitialSyncSettingsMutation,
    googleSetInitialSyncSettingsVariables as GoogleSetInitialSyncSettingsMutationVariables,
} from 'nutshell-graphql-types';

import GOOGLE_SET_INITIAL_SYNC_SETTINGS from '../mutations/google-set-initial-sync-settings.graphql';

export function useGoogleSetInitialSyncSettings() {
    const [googleSetInitialSyncSettings, {loading, error}] = useMutation<
        GoogleSetInitialSyncSettingsMutation,
        GoogleSetInitialSyncSettingsMutationVariables
    >(GOOGLE_SET_INITIAL_SYNC_SETTINGS);

    return {
        googleSetInitialSyncSettings,
        isLoading: loading,
        error,
    };
}
